import { ReactNode } from 'react';
import Consts from 'Interfaces/Consts';
import { onEnter, onDropdownFilterValueKeydown } from 'GeneralComponents/SearchAndFilter/SAFAccessibilityHelper';
import { DesktopProps } from './SAF.interface';


const SearchAndFilterDesktop: React.FC<DesktopProps> = (props) => {

    const { filters, filterValues, hasSearchInput, componentType, noFilters, disptitle, handleSubmit, onSearchInputChange, componentId, searchInputValue, updateFilterValue, searchClear } = props;
    const onSubmitBtnKeydown = async (event) => { onEnter(event, handleSubmit) };
    const onClearBtnKeydown = async (event) => { onEnter(event, searchClear) };

    const hasMoreThen4FiltersInApi = filters.filter(f => f).length > 4;
    const hasFiltersInApi = filters.filter(f => f).length > 0;

    return (
        <form
            id={`Component-Search-and-filter-${componentId}`}
            role="search"
            className={`${hasSearchInput ? 'mst-search-group row' : 'px-0'} my-auto`}
            onSubmit={(e) => handleSubmit(e)}>

            {
                // search input + clear search button
                hasSearchInput && 

                <>
                    <div className={`search-input-wrapper p-0 ${noFilters? 'no-filters col': ''} ${hasMoreThen4FiltersInApi ? 'col-12' : 'same-row-filters'}`}>

                        <label htmlFor={`componentSearchBox-${componentId}`} className="txt-invisible"><span>{Consts.componentSearch}</span></label>

                        <input className={`component-search ${searchInputValue ? 'with-content' : ''}`}
                            aria-label={disptitle}
                            autoComplete="off"
                            tabIndex={0}
                            type="text"
                            id={`componentSearchBox-${componentId}`}
                            name="search"
                            placeholder={componentType == "Alphon" ? Consts.alphonSearch : Consts.searchTyped}
                            onChange={onSearchInputChange}
                            value={searchInputValue} />

                    </div>

                    <ClearSearchButton
                        hasSeachValue={!!searchInputValue}
                        componentId={componentId}
                        onClick={searchClear}
                        onKeyDown={onClearBtnKeydown}
                    />

                    <HorizontalLineSplit show={hasMoreThen4FiltersInApi } />

                </>
            }

            {
                // Filters with dropdowns
                hasFiltersInApi &&

                <div className={
                    `filter-inputs row text-start
                    ${hasMoreThen4FiltersInApi && hasSearchInput ? 'with-5-filters' : ''} 
                    ${!hasMoreThen4FiltersInApi && hasSearchInput ? 'justify-content-end' : ''} 
                    ${hasSearchInput ? 'btn-group col-lg' : 'mx-auto'} w-100`}>

                    {
                        filters.map((item, filterIdx) => {
                            const dropdownId = `filter-dropdown-${componentId}-${filterIdx}`;                          
                            const limitDropdownMenuOverflow = item ? item.filterValues.length > 5 : "";
                            const displySplitLineStart = !hasMoreThen4FiltersInApi && hasSearchInput && (filters.findIndex(f => !!f) === filterIdx);

                            if (!item) return <EmptyFilter key={'selectFilter_' + filterIdx} />;

                            return <FilterDropdown key={'selectFilter_' + filterIdx} hasSearchInput={hasSearchInput}>

                                <FilterDropdown.Button
                                    dropdownId={dropdownId}
                                    filterName={filters[filterIdx].filterName}
                                    filterValue={filterValues[filterIdx]}
                                />

                                <FilterDropdown.Menu className={limitDropdownMenuOverflow ? 'dropdown-overflow-limit' : ''}>
                                    {
                                        item.filterValues.map((filter_value, filterValueIdx) => (

                                            <FilterDropdown.MenuOption
                                                key={filter_value + filterValueIdx}
                                                filterValue={filter_value}
                                                hasDivider={item.filterValues.length - 1 > filterValueIdx}
                                                isSelected={filter_value === filterValues[filterIdx] }
                                                onClick={() => { updateFilterValue(filter_value, filterIdx) }}
                                                onKeyDown={(e) => onDropdownFilterValueKeydown(e, dropdownId, () => updateFilterValue(filter_value, filterIdx)) }
                                            />
                                        ))
                                    }
                                </FilterDropdown.Menu>

                                <FilterDropdown.VerticalLineDivider show={hasSearchInput } />
                                {/* line split before the first filter */}
                                <FilterDropdown.VerticalLineDivider show={displySplitLineStart} className="start" />

                            </FilterDropdown>
                        })
                    }
                </div>
            }

            { hasSearchInput && <SubmitBtn onSubmitKeyDown={onSubmitBtnKeydown} /> }

        </form>

    );

}

export default SearchAndFilterDesktop;

const ClearSearchButton = ({ componentId, hasSeachValue, onClick, onKeyDown }: { hasSeachValue: boolean; onClick: (e) => void; onKeyDown: (e) => void; componentId: string; }) => {
    return <span className={`mst-term-clear ${hasSeachValue ? 'term-clear-show' : ''}`} id={`component-search-clear-${componentId}`}>
        <button
            aria-label={Consts.clean}
            className="mst-term-clear-btn "
            type="button" onClick={onClick}
            onKeyDown={onKeyDown}>
            <span className="mst-term-clear-icon">
                <svg aria-hidden="true" width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1.5L9 9.5" stroke="#3B3B3B" strokeWidth="2" strokeLinecap="round" />
                    <path d="M9 1.5L1 9.5" stroke="#3B3B3B" strokeWidth="2" strokeLinecap="round" />
                </svg>
            </span>
        </button>
    </span>
}

const FilterDropdown = ({ hasSearchInput, children }: { hasSearchInput: boolean; children: ReactNode }) => {
    return <div className={`filter-input-wrapper dropdown ${hasSearchInput ? 'col' : 'singel-input col mx-2'}`}>{children}</div>
}

const EmptyFilter = () => <div style={{ display: 'none' }}></div>;

FilterDropdown.Menu = ({ children, className }: { children: ReactNode; className: string; }) => {
    return <div className={`dropdown-menu shadow w-100 ${className}`}>{children}</div>
}

FilterDropdown.MenuOption = ({ isSelected, filterValue, hasDivider, onKeyDown, onClick }: { filterValue: string; isSelected: boolean; hasDivider: boolean; onKeyDown: (e: any) => void; onClick: () => void }) => {
    return <div>
        <button
            type="button"
            onKeyDown={onKeyDown}
            onClick={onClick}
            className={`dropdown-item ws-normal overflow-elipsis ${isSelected ? 'dropdown-selected-bg' : ''}`}>
                <i className="fa fa-check" style={{ fontSize: '12px', display: isSelected? 'inline-block': 'none' }} aria-hidden="true"></i>
                <span className={isSelected ? 'px-2' : ''}>{filterValue}</span>
        </button>
        { hasDivider && <div className="dropdown-divider mx-3"></div> }
    </div>
}

FilterDropdown.Button = ({ dropdownId, filterName, filterValue }: { filterName: string; filterValue: string; dropdownId: string; }) => {
    return <button
        type="button"
        id={dropdownId}
        className="dropdown-toggle d-flex justify-content-between px-3 align-items-center w-100 h-100 bg-transparent component-search-filter align-self-center"
        data-bs-toggle="dropdown"
        data-toggle="dropdown"
        aria-expanded="false">
        <span className="overflow-elipsis max-w-dropdown">
            {filterValue || filterName}
        </span>
        <svg className="dropdown-arrow" aria-hidden="true" width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.09156 6.45417C4.83556 6.45417 4.57956 6.35617 4.38456 6.16117L0.384559 2.16117C-0.00644141 1.77017 -0.00644141 1.13817 0.384559 0.747168C0.775559 0.356168 1.40756 0.356168 1.79856 0.747168L5.10356 4.05217L8.39656 0.872168C8.79556 0.489168 9.42656 0.500168 9.81056 0.897168C10.1946 1.29417 10.1836 1.92817 9.78656 2.31117L5.78656 6.17317C5.59156 6.36117 5.34156 6.45417 5.09156 6.45417Z" fill="#3B3B3B" />
        </svg>
    </button>
}

FilterDropdown.VerticalLineDivider = ({ className = '', show }: { className?: string; show: boolean; }) => {
    return show ? <span className={`vertical-line-split ${className}`}></span> : null;
}

const SubmitBtn = ({ onSubmitKeyDown }: { onSubmitKeyDown: (e: any) => void}) => {
    return <span className="input-group-btn mst-component-search col-auto">
        <button className="btn mst-btn search-btn" type="submit" role="button"
            onKeyDown={onSubmitKeyDown}>
            <i className="fa fa-search" aria-label={Consts.componentSearch}></i>
        </button>
    </span>
}

const HorizontalLineSplit = ({ show }: { show: boolean }) => show ? <div className="horizontal-line-split"></div> : null;


